import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AbstractService } from '@core/http/abstract.service';
import { ApiResponse } from '@app/modules/bonus-wheel/bonus-wheel.entity';

@Injectable({
  providedIn: 'root'
})
export class BonusWheelService extends AbstractService {
  protected override prefix = '/bonus-wheel';

  getQuests(): Observable<ApiResponse.QuestsResponse> {
    return this.get<ApiResponse.QuestsResponse>('/quests');
  }

  takeQuest(questId: number): Observable<ApiResponse.TakeQuestResponse> {
    return this.post<ApiResponse.TakeQuestResponse>(`/quests/${questId}/take`);
  }

  getBonusWheelStates(): Observable<ApiResponse.GetBonusWheelStatesResponse> {
    return this.get<ApiResponse.GetBonusWheelStatesResponse>(`/state`);
  }

  updateBonusWheelStates(): Observable<ApiResponse.GetBonusWheelStatesResponse> {
    return this.get<ApiResponse.GetBonusWheelStatesResponse>('/state');
  }

  spinDrum(): Observable<ApiResponse.SpinDrumResponse> {
    return this.post<ApiResponse.SpinDrumResponse>(`/spin`);
  }

  activatePromocode(code: string): Observable<void> {
    return this.post<void>(`/promocode`, { code });
  }
}
